/**
 * @generated SignedSource<<27873417dd4a7331d3b0fab17548f459>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RoadmapFavoriteSubmenu_collection$data = {
  readonly collectionId: AGG$Long;
  readonly favouriteValue: {
    readonly isFavourite: boolean | null;
  } | null;
  readonly id: string;
  readonly " $fragmentType": "RoadmapFavoriteSubmenu_collection";
};
export type RoadmapFavoriteSubmenu_collection$key = {
  readonly " $data"?: RoadmapFavoriteSubmenu_collection$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoadmapFavoriteSubmenu_collection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "RoadmapFavoriteSubmenu_collection",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "collectionId"
      },
      "action": "THROW"
    },
    {
      "concreteType": "JiraFavouriteValue",
      "kind": "LinkedField",
      "name": "favouriteValue",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isFavourite"
        }
      ]
    }
  ],
  "type": "JiraProductDiscoveryCollection"
};

(node as any).hash = "7add7039427714d8a4e0f72ca65c89fc";

export default node;
